module.exports = __webpack_public_path__ + "static/media/phone.cbbf2794.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/phone.png
 ** module id = 165
 ** module chunks = 0
 **/